import { AiUser } from './AiUser'
import { MLInferenceJob } from './MLInferenceJob'
import { Attachment, BaseModel } from './common'

export enum VideoGeneratorJobStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export interface VideoGeneratorJob extends BaseModel {
  inputImage?: Attachment
  outputVideo?: Attachment
  mlInferenceJobId: number
  mlInferenceJob?: MLInferenceJob
  jobStatus: VideoGeneratorJobStatus
  aiUserId?: number
  aiUser?: AiUser
}
